import { render, staticRenderFns } from "./ModalSuccessConfirmEmail.vue?vue&type=template&id=b5aa6fc2"
import script from "./ModalSuccessConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ModalSuccessConfirmEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports